import { defineComponent as _defineComponent } from 'vue'
import Icon from '@components/Icon.vue';

import { faChevronLeft } from '@icons/solid/faChevronLeft';

/**
 * `SplitViewPage` component properties.
 */
export interface Props {
  open: boolean;
  title?: string;
  noHeader?: boolean;
}

/**
 * `SplitViewPage` component emits.
 */
export interface Emits {
  (event: 'closed'): void;
}


const __default__ = { name: 'SplitViewPage' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    open: { type: Boolean },
    title: null,
    noHeader: { type: Boolean, default: false }
  },
  emits: ["closed"],
  setup(__props: any) {





return { __sfc: true,Icon, faChevronLeft }
}

})